import React from 'react';
import { Chip, ChipProps } from '@mui/material';

interface StatusBadgeProps extends Omit<ChipProps, 'color'> {
  status: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, ...props }) => {
  const getStatusConfig = () => {
    switch (status) {
    case 'published':
      return {
        label: 'Published',
        color: '#4CAF50',
        bgColor: 'rgba(76, 175, 80, 0.1)',
      };
    case 'in-progress':
      return {
        label: 'In Progress',
        color: '#F5B041',
        bgColor: 'rgba(245, 176, 65, 0.1)',
      };
    case 'unused':
      return {
        label: 'Unused',
        color: '#9E9E9E',
        bgColor: 'rgba(158, 158, 158, 0.1)',
      };
    case 'gifted':
      return {
        label: 'Gifted',
        color: '#9C27B0',
        bgColor: 'rgba(156, 39, 176, 0.1)',
      };
    case 'draft':
      return {
        label: 'Draft',
        color: '#FFA000',
        bgColor: 'rgba(255, 160, 0, 0.1)',
      };
    default:
      return {
        label: status.charAt(0).toUpperCase() + status.slice(1),
        color: '#9E9E9E',
        bgColor: 'rgba(158, 158, 158, 0.1)',
      };
    }
  };

  const { label, color, bgColor } = getStatusConfig();

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        color: color,
        backgroundColor: bgColor,
        borderRadius: '4px',
        fontWeight: 500,
        fontSize: '0.75rem',
        height: '24px',
        '& .MuiChip-label': {
          px: 1,
        },
      }}
      {...props}
    />
  );
};

export default StatusBadge;
